<section class="auth-card" aria-labelledby="auth-accounts-title">
  <div class="auth-card__header">
    <pa-button
      icon="pi pi-arrow-left"
      variant="outlined"
      size="small"
      severity="secondary"
      aria-label="Назад"
      (click)="back()"
    />
    <div class="auth-card__intro">
      <h1 class="auth-card__title auth-card__title--left" id="auth-accounts-title">
        Выбор учётной записи
      </h1>
      <p class="auth-card__subtitle">Выберите профиль для входа.</p>
    </div>
  </div>

  <ul class="auth-account-list" role="list">
    <li *ngFor="let a of store.accounts(); index as i" class="auth-account-list__item">
      <button
        type="button"
        class="auth-account-card"
        [ngClass]="{ 'auth-account-card--odd': i % 2 !== 0 }"
        (click)="selectAccount(a.id)"
      >
        <span class="auth-account-card__body">
          <span class="auth-account-card__name">{{ a.name }}</span>
          <span class="auth-account-card__meta">{{ accountMeta(a) }}</span>
        </span>
        <i class="pi pi-sign-in auth-account-card__icon" aria-hidden="true"></i>
      </button>
    </li>
  </ul>

  <app-support-link-v2 />
  <p class="auth-version">ver. {{ environment.appVer }}</p>
</section>
